import SEO from "@/components/SEO";

export default function MentionsLegales() {
  return (
    <>
      <SEO
        title="Mentions légales | Bati Rui"
        description="Mentions légales de Bati Rui, SARL immatriculée au RCS de Paris. SIREN 529 399 586."
        canonical="https://www.batirui.com/mentions-legales"
      />

      <section className="pt-32 pb-20 md:pt-40 md:pb-32 bg-[#F8F6F2]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1
            data-testid="mentions-h1"
            className="font-heading text-4xl sm:text-5xl font-black text-[#1B2E4B] tracking-tight mb-12"
          >
            Mentions légales
          </h1>

          <div className="space-y-10 text-[#3D3D3A] text-base leading-relaxed">
            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Editeur du site
              </h2>
              <p>
                Bati Rui — SARL au capital de 1 000 &euro;<br />
                SIREN : 529 399 586 &middot; SIRET : 529 399 586 00021<br />
                TVA : FR19 529 399 586 &middot; APE : 4339Z<br />
                45 rue de l'Espérance, 75013 Paris<br />
                Gérant : Rui Mariano Rodrigues &middot; Tél : 06 32 25 52 75
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Hébergement
              </h2>
              <p>
                Vercel Inc.<br />
                340 S Lemon Ave #4133, Walnut, CA 91789, USA<br />
                Site : vercel.com
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Propriété intellectuelle
              </h2>
              <p>
                L'ensemble du contenu de ce site (textes, photographies, logos) est la
                propriété exclusive de Bati Rui. Toute reproduction, même partielle, est
                interdite sans autorisation préalable écrite.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Données personnelles (RGPD)
              </h2>
              <p>
                Les données collectées via le formulaire de contact sont utilisées
                exclusivement pour répondre à vos demandes de devis. Elles ne sont ni
                cédées ni vendues à des tiers. Conformément au RGPD, vous disposez d'un
                droit d'accès, de rectification et de suppression en contactant Bati Rui
                à l'adresse postale ci-dessus.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Cookies
              </h2>
              <p>
                Ce site utilise uniquement des cookies techniques nécessaires à son
                fonctionnement. Aucun cookie publicitaire n'est déposé sans votre
                consentement.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1B2E4B] mb-4">
                Responsabilité
              </h2>
              <p>
                Bati Rui s'efforce de maintenir les informations de ce site à jour et
                exactes mais ne peut garantir l'exhaustivité ou l'absence d'erreurs.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
